<template>
	<b-overlay :show="isLoading">
		<div class="p-1">
			<div>
				<h1 class="font-weight-bolder">
					{{ title }}
				</h1>
				<div>
					{{ subtitle }}
				</div>
			</div>
			<div id="chart-posturas">
				<apexchart
					type="bar"
					height="350"
					:options="chartOptions"
					:series="series"
					@click="openDetail"
				></apexchart>
			</div>

			<TopSonResultDetails
				v-if="showDetail.show"
				:category_id="category_id"
				:result="result"
				:specimen="showDetail.info"
				@close="showDetail.show = false"
			/>
		</div>
	</b-overlay>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import UnbornByMadrillaModal from "@/views/amg/encaste/dashboard-encaste/components/UnbornByMadrillaModal.vue"
import SpecimenService from "@/services/specimens.service.js"
import TopSonResultDetails from "@/views/amg/specimens/components/mainDashboard/top-son-results/components/TopSonResultDetails.vue"
export default {
	name: "TopSonResultsChart",
	components: {
		apexchart: VueApexCharts,
		UnbornByMadrillaModal,
		TopSonResultDetails,
	},
	props: {
		start_date: {
			type: String,
		},
		end_date: {
			type: String,
		},
		category_id: {
			required: true,
		},
		result: {
			required: true,
		},
	},
	data() {
		return {
			isLoading: false,
			specimens: [],
			series: [
				{
					name: "",
					data: [],
				},
			],
			keyChart: 0,
			chartOptions: {
				chart: {
					type: "bar",
					height: 350,
					toolbar: {
						show: false,
					},
				},
				plotOptions: {
					bar: {
						horizontal: true,
					},
				},
				colors: ["#2C3E50"],
				legend: {
					show: false,
					showForSingleSeries: true,
					customLegendItems: ["Ranking"],
					markers: {
						// fillColors: ["#00E396", "#775DD0"],
					},
					labels: {
						colors: "#9aa0ac",
					},
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"],
				},
				xaxis: {
					labels: {
						rotate: -45,
					},
					categories: [],
					// tickPlacement: 'on'
					labels: {
						style: {
							colors: "#9aa0ac",
							// fontSize: "14px",
						},
					},
				},
				yaxis: {
					title: {
						text: "Ranking",
						style: {
							color: "#9aa0ac",
						},
					},
					labels: {
						style: {
							colors: "#9aa0ac",
							// fontSize: "14px",
						},
					},
				},
				fill: {
					type: "gradient",
					gradient: {
						shade: "light",
						type: "horizontal",
						shadeIntensity: 0.25,
						gradientToColors: undefined,
						inverseColors: true,
						opacityFrom: 0.85,
						opacityTo: 0.85,
						stops: [50, 0, 100],
					},
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return "" + val
						},
					},
				},
			},
			totalPosturas: 0,
			category: 1,
			min_eggs_registered: 0,
			pagination: {
				page: 1,
				maxPage: 2,
			},
			showDetail: {
				show: false,
				info: null,
			},
		}
	},
	async mounted() {
		await this.initChart()
	},
	computed: {
		title() {
			return `${this.category_id == 1 ? "Padrillos" : "Madrillas"}`
		},
		subtitle() {
			return `Ranking de hijos con ${this.result === "triunfo" ? "triunfos" : "derrotas"}`
		},
	},
	methods: {
		openDetail(event, chartContext, config) {
			if (event.target.classList.contains("apexcharts-bar-area")) {
				this.showDetail.info = this.specimens[config.dataPointIndex]
				this.showDetail.show = true
			}
		},
		changePagination(diff) {
			this.pagination.page += diff
		},
		async initChart() {
			this.isLoading = true
			const { data } = await SpecimenService.getTopSonResultsReport({
				category_id: this.category_id,
				limit: 10,
				result: this.result,
			})
			this.specimens = data || []
			this.chartOptions = {
				labels: data.map((item) => `${item.plate} ${item.alias ? "/" : ""} ${item.alias ? item.alias : ""}`),
				colors: ["#00cfe8", "#28c76f", "#ff9f43", "#ea5455"],
				xaxis: { labels: { trim: true, hideOverlappingLabels: false } },
			}
			this.series = [
				{
					name: `Hijos con ${this.result === "triunfo" ? "triunfos" : "derrotas"}`,
					data: data.map((item) => item.son_qty),
				},
			]
			this.isLoading = false
		},
	},
	watch: {
		async start_date() {
			await this.initChart()
		},
		async "pagination.page"() {
			await this.initChart()
		},
	},
}
</script>

<style lang="scss" scoped>
.container-card-dashboard {
	border: 2px solid #cccccc;
	border-radius: 30px;
	.header {
		border-bottom: 2px solid #cccccc;
		display: flex;
		flex-direction: column;
		// align-items: center;
		h1 {
			color: #6d6d6d;
			font-weight: 400;
			margin-bottom: 0;
		}
		.text {
			margin-bottom: 0;
			margin-left: 0.5rem;
			font-weight: bolder;
			font-size: 28px;
			// color: #000;
		}
	}
}
</style>
